<template>
  <div >
    <div  v-if="vehicle || vehicle != null" class="md-layout">
      <md-toolbar class="md-dense md-info">
        <div class="md-toolbar-section-end">
        <h3 style="flex:1"></h3>
        <!-- <md-menu md-direction="bottom-start" style="margin-right:20px;">
          <md-button style="float: right;" class="nonprint; md-info md-dense md-icon-button" md-menu-trigger><md-icon>more_vert</md-icon></md-button>
          <md-menu-content>
            <md-menu-item v-if="role.update" @click="editVehicle(vehicle.id)">Edit</md-menu-item>
            <md-menu-item v-if="role.delete" @click="deleteConfirmation(vehicle.id)">Delete</md-menu-item>
            <md-menu-item @click="backtoList">Back to Vehicle list</md-menu-item>
          </md-menu-content>
        </md-menu> -->
        <md-button class="md-icon-button md-dense md-info" @click="closeDetail()"><md-icon>close</md-icon></md-button>
        </div>
      </md-toolbar>

      <div class="md-layout-item md-size-100" >
        <md-card >
          <!-- <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <md-icon>directions_car</md-icon>
            </div>
          </md-card-header> -->
              <md-card-content>
                <div class="md-layout">
            <div class="md-layout-item md-size-100 md-small-size-100" style="margin-bottom:20px;">
              <md-table>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Vehicle No</md-table-cell>
                  <md-table-cell v-if="vehicle">{{ vehicle.vehicle_door_no }}</md-table-cell>

                  <md-table-cell style="font-weight:bold;">Production Year</md-table-cell>
                  <md-table-cell>{{ vehicle.vehicle_production_year }}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Plate No</md-table-cell>
                  <md-table-cell v-if="vehicle">{{ vehicle.vehicle_plate_no }}</md-table-cell>

                  <md-table-cell style="font-weight:bold;">Plate Color</md-table-cell>
                  <md-table-cell>
                    <span v-if="vehicle.vehicle_plate_color==0">Kuning</span>
                    <span v-if="vehicle.vehicle_plate_color==1">Hitam</span>
                  </md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Eshed</md-table-cell>
                  <md-table-cell>
                    <span v-if="vehicle.vehicle_pool==1">ICM</span>
                    <span v-if="vehicle.vehicle_pool==2">Gigashed PDC</span>
                    <span v-if="vehicle.vehicle_pool==3">ES Cikupa</span>
                    <span v-if="vehicle.vehicle_pool==4">ES Kemang</span>
                  </md-table-cell>

                  <md-table-cell style="font-weight:bold;">Registration Year</md-table-cell>
                  <md-table-cell>{{ vehicle.vehicle_registration_year }}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <!-- <md-table-cell style="font-weight:bold;">Business Unit</md-table-cell>
                  <md-table-cell>{{ vehicle.vehicle_business_unit.business_unit_name }}</md-table-cell> -->

                  <md-table-cell style="font-weight:bold;">Registration Name</md-table-cell>
                  <md-table-cell>
                    <span v-if="vehicle.vehicle_registration_name">{{ vehicle.vehicle_registration_name }}</span>
                    <span class="nodata" v-else>No Data Available</span>
                  </md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Vehicle Model</md-table-cell>
                  <md-table-cell>{{ vehicle.vehicle_type.vehicle_brands.vehicle_brand_name+"-"+vehicle.vehicle_type.vehicle_model+" "+vehicle.vehicle_type.vehicle_year_model}}</md-table-cell>

                  <md-table-cell style="font-weight:bold;">Engine No</md-table-cell>
                  <md-table-cell>{{ vehicle.vehicle_engine_no }}</md-table-cell>
                </md-table-row>
                <md-table-row>
                  <md-table-cell style="font-weight:bold;">Body Color</md-table-cell>
                  <md-table-cell>
                    <span v-if="vehicle.vehicle_body_color==0">Putih</span>
                    <span v-if="vehicle.vehicle_body_color==1">Putih Kuning</span>
                    <span v-if="vehicle.vehicle_body_color==2">Putih Metalik</span>
                    <span v-if="vehicle.vehicle_body_color==3">Hitam</span>
                    <span v-if="vehicle.vehicle_body_color==4">Hitam Metalik</span>
                    <span v-if="vehicle.vehicle_body_color==5">Silver</span>
                    <span v-if="vehicle.vehicle_body_color==6">Silver Metalik</span>
                    <span v-if="vehicle.vehicle_body_color==7">Abu Abu</span>
                    <span v-if="vehicle.vehicle_body_color==8">Abu Abu Metalik</span>
                  </md-table-cell>

                  <md-table-cell style="font-weight:bold;">Chassis No</md-table-cell>
                  <md-table-cell>{{ vehicle.vehicle_chassis_no }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            
            </div>
              </md-card-content>
        </md-card>
      </div>


      <div class="md-layout-item md-size-100">
        <tabs
          :tab-active="1"
          :tab-name="['Document', 'Accesories']"
          color-button="info"
          plain>
          
          <template slot="tab-pane-1" >
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">Document</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row>
                    <md-table-head style="text-align:center;"><b>Type</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Document No</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Expire Date</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Tax Expire Date</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Attach</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-if="vehicle.vehicle_document.length==0">
                    <md-table-cell class="nodata" colspan="6"> No Data Available </md-table-cell>
                  </md-table-row >
                  <md-table-row v-for="(item, index) in vehicle.vehicle_document" :key="index">
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_document_type==0">STNK</span>
                      <span v-if="item.vehicle_document_type==1">BPKB</span>
                      <span v-if="item.vehicle_document_type==2">KEUR</span>
                      <span v-if="item.vehicle_document_type==3">TERA</span>
                      <span v-if="item.vehicle_document_type==4">SRUT</span>
                      <span v-if="item.vehicle_document_type==5">KP</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">{{item.vehicle_document_no}}</md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_document_expire_date">{{ item.vehicle_document_expire_date }}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_document_tax_expire_date">{{ item.vehicle_document_tax_expire_date }}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_document_remark">{{item.vehicle_document_remark}}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.url_vehicle_document_file">
                      <a v-if="item.url_vehicle_document_file" :href="item.url_vehicle_document_file" target="_blank">
                        View File
                        </a></span>
                      
                      <span v-else style="">-</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </template>
          <template slot="tab-pane-2">
            <md-card>
              <md-card-header class="md-card-header-text md-card-header-green">
                <h4 class="title">Accesories</h4>
              </md-card-header>
              <md-card-content>
                <md-table>
                  <md-table-row>
                    <md-table-head style="text-align:center;"><b>Type</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Series No</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Installation Date</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Installation By</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                    <md-table-head style="text-align:center;"><b>Attach</b></md-table-head>
                  </md-table-row>
                  <md-table-row v-if="vehicle.vehicle_accessory.length==0">
                    <md-table-cell class="nodata" colspan="6"> No Data Available </md-table-cell>
                  </md-table-row >
                  <md-table-row v-else v-for="(item, index) in vehicle.vehicle_accessory" :key="index">
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_accesory_type==0">RDS+SIM-CARD</span>
                      <span v-if="item.vehicle_accesory_type==1">Bracket RDS</span>
                      <span v-if="item.vehicle_accesory_type==2">Crown</span>
                      <span v-if="item.vehicle_accesory_type==3">Emergency Lamp</span>
                      <span v-if="item.vehicle_accesory_type==4">Vacancy Lamp</span>
                      <span v-if="item.vehicle_accesory_type==5">Sticker</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_accesory_serial_no">{{item.vehicle_accesory_serial_no}}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_accesory_installation_date">{{ item.vehicle_accesory_installation_date }}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_accesory_installation_by">{{ item.vehicle_accesory_installation_by }}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.vehicle_accesory_remark">{{ item.vehicle_accesory_remark }}</span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                    <md-table-cell style="text-align:center;">
                      <span v-if="item.url_vehicle_accessory_file">
                      <a v-if="item.url_vehicle_accessory_file" :href="item.url_vehicle_accessory_file" target="_blank">
                        View File
                        </a></span>
                      <span v-else style="">-</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </md-card-content>
            </md-card>
          </template>
         
        </tabs>
        <!-- <nav-tabs-card>
        <template slot="content">
      <md-tabs class="md-success" md-alignment="centered">

        <md-tab id="tab-pages" md-label="Document" md-icon="book">
          <md-table>
              <md-table-row>
                <md-table-head style="text-align:center;"><b>Type</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Document No</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Expire Date</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Tax Expire Date</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Attach</b></md-table-head>
              </md-table-row>
              <md-table-row v-if="vehicle.vehicle_document.length==0">
                <md-table-cell class="nodata" colspan="6"> No Data Available </md-table-cell>
              </md-table-row >
              <md-table-row v-for="(item, index) in vehicle.vehicle_document" :key="index">
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_document_type==0">STNK</span>
                  <span v-if="item.vehicle_document_type==1">BPKB</span>
                  <span v-if="item.vehicle_document_type==2">KEUR</span>
                  <span v-if="item.vehicle_document_type==3">TERA</span>
                  <span v-if="item.vehicle_document_type==4">SRUT</span>
                  <span v-if="item.vehicle_document_type==5">KP</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">{{item.vehicle_document_no}}</md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_document_expire_date">{{ item.vehicle_document_expire_date }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_document_tax_expire_date">{{ item.vehicle_document_tax_expire_date }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_document_remark">{{item.vehicle_document_remark}}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.url_vehicle_document_file">
                  <a v-if="item.url_vehicle_document_file" :href="item.url_vehicle_document_file" target="_blank">
                    View File
                    </a></span>
                  
                  <span v-else style="">-</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
        </md-tab>

        <md-tab id="tab-home" md-label="Accesories" md-icon="storage">
          <md-table>
              <md-table-row>
                <md-table-head style="text-align:center;"><b>Type</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Series No</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Installation Date</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Installation By</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Attach</b></md-table-head>
              </md-table-row>
              <md-table-row v-if="vehicle.vehicle_accessory.length==0">
                <md-table-cell class="nodata" colspan="6"> No Data Available </md-table-cell>
              </md-table-row >
              <md-table-row v-else v-for="(item, index) in vehicle.vehicle_accessory" :key="index">
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_accesory_type==0">RDS+SIM-CARD</span>
                  <span v-if="item.vehicle_accesory_type==1">Bracket RDS</span>
                  <span v-if="item.vehicle_accesory_type==2">Crown</span>
                  <span v-if="item.vehicle_accesory_type==3">Emergency Lamp</span>
                  <span v-if="item.vehicle_accesory_type==4">Vacancy Lamp</span>
                  <span v-if="item.vehicle_accesory_type==5">Sticker</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_accesory_serial_no">{{item.vehicle_accesory_serial_no}}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_accesory_installation_date">{{ item.vehicle_accesory_installation_date }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_accesory_installation_by">{{ item.vehicle_accesory_installation_by }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_accesory_remark">{{ item.vehicle_accesory_remark }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.url_vehicle_accessory_file">
                  <a v-if="item.url_vehicle_accessory_file" :href="item.url_vehicle_accessory_file" target="_blank">
                    View File
                    </a></span>
                  <span v-else style="">-</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
        </md-tab>

        <md-tab id="tab-mccs" md-label="MCCS" md-icon="gps_fixed">
          <md-table>
              <md-table-row>
                <md-table-head style="text-align:center;"><b>Serial No</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Installation Date</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Installation By</b></md-table-head>
                <md-table-head style="text-align:center;"><b>Remark</b></md-table-head>
              </md-table-row>
              <md-table-row v-if="vehicle.vehicle_mccs.length==0">
                <md-table-cell class="nodata" colspan="4"> No Data Available </md-table-cell>
              </md-table-row >
              <md-table-row v-else v-for="(item, index) in vehicle.vehicle_mccs" :key="index">
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_mccs_serial_no">{{item.vehicle_mccs_serial_no}}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_mccs_installation_date">{{ item.vehicle_mccs_installation_date }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_mccs_installation_by">{{ item.vehicle_mccs_installation_by }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
                <md-table-cell style="text-align:center;">
                  <span v-if="item.vehicle_mccs_remark">{{ item.vehicle_mccs_remark }}</span>
                  <span v-else style="">-</span>
                </md-table-cell>
              </md-table-row>
            </md-table>
        </md-tab>
      </md-tabs>
        </template>
        </nav-tabs-card> -->
      </div>
    </div>
          
    <div v-bind:style="{ display: not_found}">
      <center  v-if="vehicle == null">
        <h1>Not Found!</h1>
        <p>
          <a href="" @click="backToList()">Back To List?</a>
        </p>
      </center>
    </div>
  </div>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import Swal from 'sweetalert2';
import { NavTabsCard, Tabs } from "@/components";


import Vue from "vue";

const url_storage = process.env.VUE_APP_STORAGE_BASE_URL;
const toLower = (text) => {
  var rt = "";
  if (text) {
    rt = text.toString().toLowerCase();
  }
  return rt;
};
export default {
  name: "detail-vehicles",

  components:{
     Tabs
  },

  props: {
    data_id: null,
    },


  mixins: [formMixin],

  data: () => ({
    not_found: 'none',
    role:"",
    vehicle: null,
    url_storage : url_storage,
    

  }),

  created() {
    this.getVehicleData();
  },

  methods: {
    //fungsi yang berjalan saat page pertamakali dibuka
    async getVehicleData(){
      //ambil list role permission user
      this.role =  await this.$store.getters["role_permission/route_filter"]
      // console.log(this.role)
      //ambil data se sesuai dengan id yang ikut juga dikirim melalui route
      await this.$store.dispatch("workshop_vehicle/get", this.data_id.id)
      this.vehicle = await this.$store.getters["workshop_vehicle/vehicle"]
        if(!this.vehicle){
        this.not_found = "block"
          return
        }
    },

    async closeDetail(){
      this.$parent.$parent.modalCloseDetail();
    },

    // fungsi currency number
    formatPrice(value) {
      let val = (value/1).toFixed().replace('.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    // direct ke edit form
    editVehicle(id) {
      //pindah ke page edit, id juga ikut dikirim melalui route
      this.$router.replace({ name: 'Edit Vehicle', params: {vehicle: id, id } })
    },
  
    // direct ke list view table
    backtoList() {
      //kembali ke list
      this.$router.replace({ name: 'List Vehicle'})
    },

    // validasi delete data
    deleteConfirmation(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You wont be able to revert this!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.deleteVehicle(id)
        }
      });
    },
    
    // fungsi delete data
    async deleteVehicle(id) {
      try {
        //kirim data ke server
        await this.$store.dispatch("workshop_vehicle/destroy", id)
        //panggil alert succes
        await this.$store.dispatch("alerts/success", "Vehicle data delete successfully.")
        //kembali ke page list
        this.$router.replace({ name: 'List Vehicle'})
      } catch (e) {
        //panggil alert error
        await this.$store.dispatch("alerts/error", "Oops, something went wrong!")
        this.setApiValidation(e.response.data.errors)
      }
    },
    
      
  }
};
</script>
<style scoped>
.title-name{
  background-color:powderblue;
}
table{
  width:100%;
  table-layout: fixed;
}
.table-kotak{
  border-collapse: collapse;
}
table.table-kotak td{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
table.table-kotak th{
  border: 1px solid black;
  padding-left: 5px;
  padding-right: 5px;
}
.print{
  visibility: hidden;
}
@media print{
   .print{
       visibility: visible;
   }
   .noprint{
     display: none;
   }

  
}
.photo_list{
    max-width: 50%;
    height: auto;
    display: block;
    /* margin-left: auto;
    margin-right: auto; */
}

.nodata{
  
  color:#aaa;
  text-align: center;
}

.color{
    background-color: #1976d2 !important;
    box-shadow: none !important;

}
</style>